import { request } from '@/utils/request/request';
// 添加工作
export function submitWork(data) {
  return request({
    url: 'api/maintain/v1/MaintainWorkListEdit',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
}
// 获取列表
export function getWorkList(data) {
  return request({
    url: 'api/maintain/v1/GetMaintainWorkLists',
    method: 'GET',
    params: data,
  });
}
// 获取类型列表
export function getTypeList(data) {
  return request({
    url: 'api/',
    method: 'GET',
    params: data,
  });
}
// 获取运维技师列表
export function getOperationTechnicians(data = {}) {
  return request({
    url: 'api/maintain/v1/YunWeiJiShi',
    method: 'GET',
    params: data,
  });
}
